module.exports = __webpack_public_path__ + "static/MF22_Win-2406f65519a7c7f3e4a7063bfa5a11a3.jpg";